<template>
  <div class="flex flex-col">
    <p v-if="neverExpires" class="text-sm text-gray-500 mt-1">
      {{ __('Never Expires') }}
    </p>
    <p v-else-if="isExpired" class="text-sm text-zinc-600 mt-1 mb-3">
      {{ __('Expired on {date}', { date: formattedEndDate }) }}
    </p>
    <p v-else-if="isActive" class="text-sm text-zinc-600 mt-1 mb-3">
      {{ getExpirationText() }}
    </p>
    <div v-if="!neverExpires" class="relative w-full h-2 bg-gray-200 rounded-full overflow-hidden">
      <div
          class="h-full transition-all duration-500 bg-secondary"
          :style="{ width: `${progressPercentage}%` }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import {__} from "@/helpers";

const props = defineProps({
  startDate: { type: String, default: null },
  endDate: { type: String, default: null },
  neverExpires: { type: Boolean, default: false }
});

const isActive = computed(() => {
  if (props.neverExpires) return false;
  if (!props.endDate) return false;
  return new Date() < new Date(props.endDate);
});

const isExpired = computed(() => {
  if (props.neverExpires) return false;
  if (!props.endDate) return false;
  return new Date() > new Date(props.endDate);
});

const progressPercentage = computed(() => {
  if (props.neverExpires) return 100;
  if (!props.startDate || !props.endDate) return 0;
  const start = new Date(props.startDate);
  const end = new Date(props.endDate);
  const now = new Date();
  if (now < start) return 0;
  if (now > end) return 100;
  const total = end - start;
  const elapsed = now - start;
  return Math.round((elapsed / total) * 100);
});

const getExpirationText = () => {
  if (props.neverExpires) return '';
  if (!props.endDate) return '';
  const endDate = new Date(props.endDate);
  const now = new Date();
  const diffDays = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return __('Expired');
  if (diffDays === 0) return __('Expires today');
  if (diffDays === 1) return __('Expires tomorrow');
  return __('Expires in {days} days.', { days: diffDays });
};

const formattedEndDate = computed(() => {
  if (props.neverExpires) return '';
  if (!props.endDate) return '';

  const d = new Date(props.endDate);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();

  return `${dd}.${mm}.${yyyy}`;
});
</script>
